module.exports = __webpack_public_path__ + "static/img/DYSON-SHARP.a85b3e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DYSON-SHARP.jpg
// module id = EvR1
// module chunks = 0